import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';
import './style.scss';

const ServerError = () => {
  const { t } = useTranslation();
  const path = typeof window !== 'undefined' && window.location.href || '';

  return (
    <div className="ServerError">
      <h1>{t('general.500.title')}</h1>
      <p>{t('general.500.body', { path })}</p>
      <Button primary href={t('general.500.primary_button.url')} className="icon-after icon-arrow icon-variant-1">{t('general.500.primary_button.link')}</Button>
    </div>
  );
};

export default ServerError;
